import 'src/lib/polyfills'

import * as Sentry from '@sentry/react'

import { CedarProvider } from '@cedarjs/web'
import { CedarApolloProvider } from '@cedarjs/web/apollo/CedarApolloProvider'

import FatalErrorPage from 'src/pages/FatalErrorPage'
import Routes from 'src/Routes'

import { AuthProvider, useAuth } from './auth'

import './scaffold.css'
import './index.css'

const App = () => (
  // @ts-expect-error https://community.redwoodjs.com/t/redwood-v8-0-0-upgrade-guide/7250/51?u=cdubz
  <Sentry.ErrorBoundary fallback={FatalErrorPage}>
    <CedarProvider titleTemplate="%PageTitle | %AppTitle">
      <AuthProvider>
        <CedarApolloProvider
          useAuth={useAuth}
          graphQLClientConfig={{
            httpLinkConfig: { credentials: 'include' },
          }}
        >
          <Routes />
        </CedarApolloProvider>
      </AuthProvider>
    </CedarProvider>
  </Sentry.ErrorBoundary>
)

export default App
